export default "__VITE_ASSET__B4mQYu0s__"